import { cn } from 'src/shared/utils/cn'

type BreadcrumbsProps = {
  breadcrumbs: {
    label: string
    onClick?: () => void
  }[]
  className?: string
}

const Breadcrumbs = ({ breadcrumbs, className }: BreadcrumbsProps) => {
  return (
    <div className={cn('flex items-center gap-[3px]', className)}>
      {breadcrumbs.map((breadcrumb, index) => {
        const isLast = index === breadcrumbs.length - 1

        return (
          <div key={`${breadcrumb.label}-${index}`} className="flex items-center gap-[3px]">
            <button
              className={isLast ? 'text-base leading-3 text-primary' : 'text-base leading-3 text-muted'}
              onClick={breadcrumb.onClick}
              disabled={isLast}
            >
              {breadcrumb.label}
            </button>
            {!isLast && <span className="mx-2 -mt-px text-xl leading-3 text-muted">/</span>}
          </div>
        )
      })}
    </div>
  )
}

export default Breadcrumbs
